import { environment } from '../../environments/environment';

// Classic ↔ new frontend switch. Mirrors ClassicAppService in frontend_v3: each app keeps its own
// copy of the choice (localStorage is per-origin), and the switch links carry `?frontend=` so the
// receiving app overwrites its stale copy instead of bouncing the user back.

// Classic-app hostname → new-app dashboard.
const NEW_APP_URLS: Record<string, string> = {
  'app.inscyd.com': 'https://next.prod.inscyd.com/dashboard',
  'app.test.inscyd.com': 'https://next.test.inscyd.com/dashboard',
  'app.dev.inscyd.com': 'https://next.dev.inscyd.com/dashboard',
};

const STORAGE_KEY = 'frontend';
const PARAM = 'frontend';

function resolveTarget(): string | null {
  const target = NEW_APP_URLS[location.hostname];
  // Guard against a target that is this very app — redirecting would loop.
  return target && new URL(target).origin !== location.origin ? target : null;
}

const target = resolveTarget();

/** Where "Try the new INSCYD" points, or null when the switch is disabled here. */
export const newAppUrl: string | null = target ? `${target}?${PARAM}=new` : null;

/**
 * Runs before bootstrap. An explicit `?frontend=` wins and is stored; otherwise a stored 'new'
 * choice redirects. Returns true while redirecting so the caller can skip bootstrapping.
 */
export function applyFrontendChoice(): boolean {
  if (!newAppUrl) return false;

  const url = new URL(location.href);
  const requested = url.searchParams.get(PARAM);

  if (requested === 'classic' || requested === 'new') {
    localStorage.setItem(STORAGE_KEY, requested);
    url.searchParams.delete(PARAM);
    history.replaceState(history.state, '', url);
    return false;
  }

  if (localStorage.getItem(STORAGE_KEY) === 'new') {
    location.replace(newAppUrl);
    return true;
  }

  return false;
}

export function chooseNewApp(): void {
  localStorage.setItem(STORAGE_KEY, 'new');
}
